import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "wordBreak",
  standalone: true,
})
export class WordBreakPipe implements PipeTransform {
  transform(value: string | null | undefined, maxLineLength: number = 50): string {
    if (!value) {
      return "";
    }

    if (value.includes(" ")) {
      return value;
    }

    let text = value.replace(/\r\n|\r|\n/g, "<br>");

    const segments = text.split("<br>");
    const result: string[] = [];

    for (const segment of segments) {
      if (segment.length <= maxLineLength) {
        result.push(segment);
        continue;
      }

      const words = segment.split("");
      const lines: string[] = [];
      let currentLine = "";

      for (const word of words) {
        if (currentLine.length === 0) {
          currentLine = word;
        } else if ((currentLine + "" + word).length <= maxLineLength) {
          currentLine += "" + word;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }

      if (currentLine.length > 0) {
        lines.push(currentLine);
      }

      result.push(lines.join("<br>"));
    }

    return result.join("<br>");
  }
}
